export default {
  defaultDaysToExpire: 14,
  sharedStateKey: 'shared-state',
};
